import React, { useState } from 'react';
import _ from 'lodash';
import cn from 'classnames';

import ProgressBar from '../ProgressBar/ProgressBar';
import ImportantNote from './ImportantNote';

import styles from './Steps.module.css';

const Step15 = (props) => {
  const { onSave, stepsData } = props;
  const [mealsPerDay, setMealsPerDay] = useState(stepsData.meals_per_day);
  const [showNote, setShowNote] = useState(false);

  const onFinishSave = (meals) => {
    onSave({ meals_per_day: meals });
  };

  const onSaveHandler = (meals) => {
    if (meals !== 4) {
      setMealsPerDay(meals);
      setShowNote(true);
      return;
    }
    onFinishSave(meals);
  };

  if (showNote) {
    return (
      <ImportantNote
        className={styles.mealPerDayImportantNote}
        title="Recommendation for you and your meal plan"
        message="In our app we suggest 4 meals per day as a base to make sure you get all the nutrients and move towards your goal. We will have more options in the future App releases."
        onClick={() => onFinishSave(mealsPerDay)}
      />
    );
  }

  return (
    <div className={styles.stepWrapper}>
      <ProgressBar onSave={onSave} />
      <div className={styles.mealsPerDayContent}>
        <div className={styles.stepHeader}>
          How many meals per day do you usually have?
        </div>
        <div className={styles.daysSelect}>
          {_.times(4).map((_, index) => {
            const meals = index + 2;
            return (
              <div 
                key={index} 
                className={cn(styles.dayButton, { [styles.active]: meals == mealsPerDay})}
                onClick={() => onSaveHandler(meals)}
              >
                {meals}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Step15;